/*LIBRARY*/
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

/*COMPONENT*/
import FOLDER_CHILD from "./FOLDER_CHILD";
import Modal from "../common_modal/Modal";

/*REDUX*/
import {
  get_all_folder_project_list_by_user_id,
  move_folder_to_another_folder,
} from "../../App/actions/folderProjectAction";
import {
  set_value_project,
  push_value_project,
} from "../../App/actions/projectActions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const MOVE_FOLDER_TO_FOLDER = ({ auth, folder, toggle_move_folder }) => {
  const dispatch = useDispatch();

  //global props
  const {
    folder_project_list_all,
    folder_id_selected_move,
    folder_object_selected_list,
    folder_id_selected,
  } = useSelector((state) => state.project);

  //local state
  const [modal_warn, set_modal_warn] = useState(false);

  useEffect(() => {
    dispatch(get_all_folder_project_list_by_user_id());
  }, [dispatch]);

  const toggle_warn = () => {
    set_modal_warn((prev) => !prev);
  };

  const on_click_folder = (folder_id) => {
    if (folder_id !== folder_id_selected) {
      dispatch(
        set_value_project({
          key: "folder_id_selected_move",
          value: folder_id,
        }),
      );
    }
  };

  const on_move_folder_to_another_folder = () => {
    if (
      folder_id_selected === folder_id_selected_move ||
      !folder_id_selected_move
    ) {
      toggle_warn();
    } else {
      const key =
        folder_object_selected_list.length === 0
          ? "folder_project_list"
          : "folder_project_child_list";

      const body = {
        key,
        folder_id: folder?._id,
        folder_parent_id: folder_id_selected_move,
      };

      dispatch(move_folder_to_another_folder(body));
      toggle_move_folder();
    }
  };

  const on_remove = () => {
    const body = {
      key: "folder_project_child_list",
      folder_id: folder?._id,
      folder_parent_id: "",
    };
    dispatch(move_folder_to_another_folder(body));
    toggle_move_folder();
    //folder_project_list
    dispatch(
      push_value_project({
        key: "folder_project_list",
        value: folder,
      }),
    );
  };

  //local storage
  const language = localStorage?.language || auth?.language;

  const filtered_folder_project_list_all = folder_project_list_all.filter(
    (item) => item._id !== folder?._id,
  );

  //content
  const folder_parent_list = filtered_folder_project_list_all.filter(
    (item) => !item?.folder_parent_id,
  );

  const modal_warn_content = modal_warn && (
    <Modal modalSize="small" isOpen={modal_warn} onClose={toggle_warn}>
      <div className="box-body" id="box-body">
        {dict?.["Please select a folder first"]?.[language]}
      </div>
    </Modal>
  );

  return (
    <main>
      {modal_warn_content}

      <section
        className="margin_bottom"
        style={{
          maxHeight: "calc(( 70vh - 200px ))",
          height: "calc(( 70vh - 200px ))",
          overflowY: "scroll",
        }}
      >
        {folder_parent_list.map((item, idx) => {
          const folder_list_child = filtered_folder_project_list_all.filter(
            (child) => child?.folder_parent_id === item?._id,
          );
          return (
            <div key={item?._id || idx} className="margin_bottom">
              <div
                className={`container_folder background_white background_white cursor_pointer ${
                  item._id === folder_id_selected_move
                    ? "outline_blue"
                    : "outline_grey"
                }`}
                onClick={() => on_click_folder(item?._id)}
              >
                <table className="full_width">
                  <tbody>
                    <tr>
                      <td>
                        <p
                          className="max_one_lines"
                          style={{
                            marginTop: "auto",
                            marginBottom: "auto",
                          }}
                        >
                          {item?.name}
                        </p>
                      </td>
                      {folder_id_selected_move === item?._id && (
                        <td className="text_right">
                          <span className="badge_circle_small background_green" />
                        </td>
                      )}
                    </tr>
                  </tbody>
                </table>
              </div>

              {folder_id_selected === item?._id && (
                <div className="badge">Current</div>
              )}

              {folder_list_child?.length > 0 && (
                <FOLDER_CHILD
                  folder_id_selected={folder_id_selected}
                  folder_parent_id={item?._id}
                  folder_list_child={folder_list_child}
                  folder_project_list_all={filtered_folder_project_list_all}
                  on_click_folder={on_click_folder}
                  folder_id_selected_move={folder_id_selected_move}
                />
              )}
            </div>
          );
        })}
      </section>

      <section className="margin_top">
        <button
          className={`button margin_right margin_bottom ${
            folder_id_selected_move ? "background_black" : "background_grey"
          }`}
          onClick={on_move_folder_to_another_folder}
        >
          {dict?.["Move"]?.[language]}
        </button>
        {folder_object_selected_list.length > 0 && (
          <button className="button background_black" onClick={on_remove}>
            {dict?.["Remove from folder"]?.[language]}
          </button>
        )}
      </section>
    </main>
  );
};

export default MOVE_FOLDER_TO_FOLDER;
